/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { CustomerAddressModel } from "../models";
// @ts-ignore
import { CustomerAddressModelODataResultCollection } from "../models";
/**
 * CustomerAddressApi - axios parameter creator
 * @export
 */
export const CustomerAddressApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Gets the list of customers.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCustomerAddressGet: async (
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomerAddress`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Gets the address list by contract number.
     * @param {number} contractNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCustomerAddressShipToAddressesContractNumberGet: async (
      contractNumber: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contractNumber' is not null or undefined
      assertParamExists(
        "apiCustomerAddressShipToAddressesContractNumberGet",
        "contractNumber",
        contractNumber
      );
      const localVarPath =
        `/api/CustomerAddress/ShipToAddresses/{contractNumber}`.replace(
          `{${"contractNumber"}}`,
          encodeURIComponent(String(contractNumber))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} contractNumber
     * @param {string} warehouseCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet: async (
      contractNumber: number,
      warehouseCode: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contractNumber' is not null or undefined
      assertParamExists(
        "apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet",
        "contractNumber",
        contractNumber
      );
      // verify required parameter 'warehouseCode' is not null or undefined
      assertParamExists(
        "apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet",
        "warehouseCode",
        warehouseCode
      );
      const localVarPath =
        `/api/CustomerAddress/ShipToAddresses/{contractNumber}/{warehouseCode}`
          .replace(
            `{${"contractNumber"}}`,
            encodeURIComponent(String(contractNumber))
          )
          .replace(
            `{${"warehouseCode"}}`,
            encodeURIComponent(String(warehouseCode))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} contractNumber
     * @param {string} warehouseCode
     * @param {string} modeOfTransportationCode
     * @param {string} salesTermsCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet:
      async (
        contractNumber: number,
        warehouseCode: string,
        modeOfTransportationCode: string,
        salesTermsCode: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'contractNumber' is not null or undefined
        assertParamExists(
          "apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet",
          "contractNumber",
          contractNumber
        );
        // verify required parameter 'warehouseCode' is not null or undefined
        assertParamExists(
          "apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet",
          "warehouseCode",
          warehouseCode
        );
        // verify required parameter 'modeOfTransportationCode' is not null or undefined
        assertParamExists(
          "apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet",
          "modeOfTransportationCode",
          modeOfTransportationCode
        );
        // verify required parameter 'salesTermsCode' is not null or undefined
        assertParamExists(
          "apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet",
          "salesTermsCode",
          salesTermsCode
        );
        const localVarPath =
          `/api/CustomerAddress/ShipToAddresses/{contractNumber}/{warehouseCode}/{modeOfTransportationCode}/{salesTermsCode}`
            .replace(
              `{${"contractNumber"}}`,
              encodeURIComponent(String(contractNumber))
            )
            .replace(
              `{${"warehouseCode"}}`,
              encodeURIComponent(String(warehouseCode))
            )
            .replace(
              `{${"modeOfTransportationCode"}}`,
              encodeURIComponent(String(modeOfTransportationCode))
            )
            .replace(
              `{${"salesTermsCode"}}`,
              encodeURIComponent(String(salesTermsCode))
            );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKeyAuth required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "X-Api-Key",
          configuration
        );

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     *
     * @param {number} contractNumber
     * @param {string} warehouseCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractNumberwarehouseCodeGet: async (
      contractNumber: number,
      warehouseCode: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contractNumber' is not null or undefined
      assertParamExists(
        "contractNumberwarehouseCodeGet",
        "contractNumber",
        contractNumber
      );
      // verify required parameter 'warehouseCode' is not null or undefined
      assertParamExists(
        "contractNumberwarehouseCodeGet",
        "warehouseCode",
        warehouseCode
      );
      const localVarPath =
        `/api/CustomerAddress/ShipToAddresses({contractNumber},{warehouseCode})`
          .replace(
            `{${"contractNumber"}}`,
            encodeURIComponent(String(contractNumber))
          )
          .replace(
            `{${"warehouseCode"}}`,
            encodeURIComponent(String(warehouseCode))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} contractNumber
     * @param {string} warehouseCode
     * @param {string} modeOfTransportationCode
     * @param {string} salesTermsCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet:
      async (
        contractNumber: number,
        warehouseCode: string,
        modeOfTransportationCode: string,
        salesTermsCode: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'contractNumber' is not null or undefined
        assertParamExists(
          "contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet",
          "contractNumber",
          contractNumber
        );
        // verify required parameter 'warehouseCode' is not null or undefined
        assertParamExists(
          "contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet",
          "warehouseCode",
          warehouseCode
        );
        // verify required parameter 'modeOfTransportationCode' is not null or undefined
        assertParamExists(
          "contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet",
          "modeOfTransportationCode",
          modeOfTransportationCode
        );
        // verify required parameter 'salesTermsCode' is not null or undefined
        assertParamExists(
          "contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet",
          "salesTermsCode",
          salesTermsCode
        );
        const localVarPath =
          `/api/CustomerAddress/ShipToAddresses({contractNumber},{warehouseCode},{modeOfTransportationCode},{salesTermsCode})`
            .replace(
              `{${"contractNumber"}}`,
              encodeURIComponent(String(contractNumber))
            )
            .replace(
              `{${"warehouseCode"}}`,
              encodeURIComponent(String(warehouseCode))
            )
            .replace(
              `{${"modeOfTransportationCode"}}`,
              encodeURIComponent(String(modeOfTransportationCode))
            )
            .replace(
              `{${"salesTermsCode"}}`,
              encodeURIComponent(String(salesTermsCode))
            );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication apiKeyAuth required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "X-Api-Key",
          configuration
        );

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
  };
};

/**
 * CustomerAddressApi - functional programming interface
 * @export
 */
export const CustomerAddressApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    CustomerAddressApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Gets the list of customers.
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCustomerAddressGet(
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CustomerAddressModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomerAddressGet(
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Gets the address list by contract number.
     * @param {number} contractNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCustomerAddressShipToAddressesContractNumberGet(
      contractNumber: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CustomerAddressModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomerAddressShipToAddressesContractNumberGet(
          contractNumber,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} contractNumber
     * @param {string} warehouseCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet(
      contractNumber: number,
      warehouseCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CustomerAddressModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet(
          contractNumber,
          warehouseCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} contractNumber
     * @param {string} warehouseCode
     * @param {string} modeOfTransportationCode
     * @param {string} salesTermsCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet(
      contractNumber: number,
      warehouseCode: string,
      modeOfTransportationCode: string,
      salesTermsCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CustomerAddressModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet(
          contractNumber,
          warehouseCode,
          modeOfTransportationCode,
          salesTermsCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} contractNumber
     * @param {string} warehouseCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractNumberwarehouseCodeGet(
      contractNumber: number,
      warehouseCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CustomerAddressModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractNumberwarehouseCodeGet(
          contractNumber,
          warehouseCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} contractNumber
     * @param {string} warehouseCode
     * @param {string} modeOfTransportationCode
     * @param {string} salesTermsCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet(
      contractNumber: number,
      warehouseCode: string,
      modeOfTransportationCode: string,
      salesTermsCode: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<CustomerAddressModel>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet(
          contractNumber,
          warehouseCode,
          modeOfTransportationCode,
          salesTermsCode,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * CustomerAddressApi - factory interface
 * @export
 */
export const CustomerAddressApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CustomerAddressApiFp(configuration);
  return {
    /**
     *
     * @summary Gets the list of customers.
     * @param {CustomerAddressApiApiCustomerAddressGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCustomerAddressGet(
      requestParameters: CustomerAddressApiApiCustomerAddressGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<CustomerAddressModelODataResultCollection> {
      return localVarFp
        .apiCustomerAddressGet(
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Gets the address list by contract number.
     * @param {CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCustomerAddressShipToAddressesContractNumberGet(
      requestParameters: CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<CustomerAddressModel>> {
      return localVarFp
        .apiCustomerAddressShipToAddressesContractNumberGet(
          requestParameters.contractNumber,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet(
      requestParameters: CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<CustomerAddressModel>> {
      return localVarFp
        .apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet(
          requestParameters.contractNumber,
          requestParameters.warehouseCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet(
      requestParameters: CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<CustomerAddressModel>> {
      return localVarFp
        .apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet(
          requestParameters.contractNumber,
          requestParameters.warehouseCode,
          requestParameters.modeOfTransportationCode,
          requestParameters.salesTermsCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CustomerAddressApiContractNumberwarehouseCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractNumberwarehouseCodeGet(
      requestParameters: CustomerAddressApiContractNumberwarehouseCodeGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<CustomerAddressModel>> {
      return localVarFp
        .contractNumberwarehouseCodeGet(
          requestParameters.contractNumber,
          requestParameters.warehouseCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet(
      requestParameters: CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<Array<CustomerAddressModel>> {
      return localVarFp
        .contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet(
          requestParameters.contractNumber,
          requestParameters.warehouseCode,
          requestParameters.modeOfTransportationCode,
          requestParameters.salesTermsCode,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiCustomerAddressGet operation in CustomerAddressApi.
 * @export
 * @interface CustomerAddressApiApiCustomerAddressGetRequest
 */
export interface CustomerAddressApiApiCustomerAddressGetRequest {
  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof CustomerAddressApiApiCustomerAddressGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof CustomerAddressApiApiCustomerAddressGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof CustomerAddressApiApiCustomerAddressGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof CustomerAddressApiApiCustomerAddressGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiCustomerAddressShipToAddressesContractNumberGet operation in CustomerAddressApi.
 * @export
 * @interface CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberGetRequest
 */
export interface CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberGetRequest {
  /**
   *
   * @type {number}
   * @memberof CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberGet
   */
  readonly contractNumber: number;
}

/**
 * Request parameters for apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet operation in CustomerAddressApi.
 * @export
 * @interface CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeGetRequest
 */
export interface CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeGetRequest {
  /**
   *
   * @type {number}
   * @memberof CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet
   */
  readonly contractNumber: number;

  /**
   *
   * @type {string}
   * @memberof CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet
   */
  readonly warehouseCode: string;
}

/**
 * Request parameters for apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet operation in CustomerAddressApi.
 * @export
 * @interface CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGetRequest
 */
export interface CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGetRequest {
  /**
   *
   * @type {number}
   * @memberof CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet
   */
  readonly contractNumber: number;

  /**
   *
   * @type {string}
   * @memberof CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet
   */
  readonly warehouseCode: string;

  /**
   *
   * @type {string}
   * @memberof CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet
   */
  readonly modeOfTransportationCode: string;

  /**
   *
   * @type {string}
   * @memberof CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet
   */
  readonly salesTermsCode: string;
}

/**
 * Request parameters for contractNumberwarehouseCodeGet operation in CustomerAddressApi.
 * @export
 * @interface CustomerAddressApiContractNumberwarehouseCodeGetRequest
 */
export interface CustomerAddressApiContractNumberwarehouseCodeGetRequest {
  /**
   *
   * @type {number}
   * @memberof CustomerAddressApiContractNumberwarehouseCodeGet
   */
  readonly contractNumber: number;

  /**
   *
   * @type {string}
   * @memberof CustomerAddressApiContractNumberwarehouseCodeGet
   */
  readonly warehouseCode: string;
}

/**
 * Request parameters for contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet operation in CustomerAddressApi.
 * @export
 * @interface CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGetRequest
 */
export interface CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGetRequest {
  /**
   *
   * @type {number}
   * @memberof CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet
   */
  readonly contractNumber: number;

  /**
   *
   * @type {string}
   * @memberof CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet
   */
  readonly warehouseCode: string;

  /**
   *
   * @type {string}
   * @memberof CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet
   */
  readonly modeOfTransportationCode: string;

  /**
   *
   * @type {string}
   * @memberof CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet
   */
  readonly salesTermsCode: string;
}

/**
 * CustomerAddressApi - object-oriented interface
 * @export
 * @class CustomerAddressApi
 * @extends {BaseAPI}
 */
export class CustomerAddressApi extends BaseAPI {
  /**
   *
   * @summary Gets the list of customers.
   * @param {CustomerAddressApiApiCustomerAddressGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerAddressApi
   */
  public apiCustomerAddressGet(
    requestParameters: CustomerAddressApiApiCustomerAddressGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CustomerAddressApiFp(this.configuration)
      .apiCustomerAddressGet(
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Gets the address list by contract number.
   * @param {CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerAddressApi
   */
  public apiCustomerAddressShipToAddressesContractNumberGet(
    requestParameters: CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CustomerAddressApiFp(this.configuration)
      .apiCustomerAddressShipToAddressesContractNumberGet(
        requestParameters.contractNumber,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerAddressApi
   */
  public apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet(
    requestParameters: CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CustomerAddressApiFp(this.configuration)
      .apiCustomerAddressShipToAddressesContractNumberWarehouseCodeGet(
        requestParameters.contractNumber,
        requestParameters.warehouseCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerAddressApi
   */
  public apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet(
    requestParameters: CustomerAddressApiApiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CustomerAddressApiFp(this.configuration)
      .apiCustomerAddressShipToAddressesContractNumberWarehouseCodeModeOfTransportationCodeSalesTermsCodeGet(
        requestParameters.contractNumber,
        requestParameters.warehouseCode,
        requestParameters.modeOfTransportationCode,
        requestParameters.salesTermsCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CustomerAddressApiContractNumberwarehouseCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerAddressApi
   */
  public contractNumberwarehouseCodeGet(
    requestParameters: CustomerAddressApiContractNumberwarehouseCodeGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CustomerAddressApiFp(this.configuration)
      .contractNumberwarehouseCodeGet(
        requestParameters.contractNumber,
        requestParameters.warehouseCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerAddressApi
   */
  public contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet(
    requestParameters: CustomerAddressApiContractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CustomerAddressApiFp(this.configuration)
      .contractNumberwarehouseCodemodeOfTransportationCodesalesTermsCodeGet(
        requestParameters.contractNumber,
        requestParameters.warehouseCode,
        requestParameters.modeOfTransportationCode,
        requestParameters.salesTermsCode,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
